import { connect } from 'react-redux';
import { actions } from '../../../redux/modules/predictiveAnalysis/predictiveAnalysis';
import { actions as emergencyTypeActions } from '../../../redux/modules/emergencyTypes/emergencyTypes';
import PredictivePage from './PredictivePage';

const ms2p = (state) => ({
    predictiveAnalysis: state.predictiveAnalysis,
    emergencyTypes: state.emergencyTypes.data ? state.emergencyTypes.data.results : [],
});

const md2p = {
    ...actions,
    getEmergencyTypes: emergencyTypeActions.listar,
};

export default connect(ms2p, md2p)(PredictivePage);
